var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFillRegisterQuick = function SvgFillRegisterQuick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 40,
    x: 8,
    y: 4,
    fill: "#E3E6E9",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#757C83",
    d: "m13.527 35.53.666-1.177L13 33.811l.25-.757 1.271.296.13-1.35h.776l.129 1.35 1.264-.296.239.757-1.204.542.696 1.176-.636.471-.876-1.033L14.142 36zM18.5 35.529l.666-1.176-1.193-.542.248-.757 1.273.296.13-1.35h.777l.127 1.35 1.264-.296.239.757-1.204.542.696 1.176-.637.471-.875-1.033L19.115 36zM23.47 35.529l.667-1.176-1.193-.542.25-.757 1.271.296.13-1.35h.776l.129 1.35 1.257-.296.239.757-1.204.542.696 1.176-.636.471-.876-1.033L24.081 36zM28.449 35.529l.666-1.176-1.193-.542.248-.757 1.273.296.13-1.35h.776l.128 1.35 1.258-.296.239.757-1.204.542.696 1.176-.637.471-.874-1.033L29.058 36zM34.044 32H35v3.817h-.956z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E79FF",
    fillRule: "evenodd",
    d: "M33 27.714H15C15 23.454 19.03 20 24 20s9 3.454 9 7.714M24 11a3.857 3.857 0 1 0 0 7.714A3.857 3.857 0 0 0 24 11",
    clipRule: "evenodd"
  })));
};
export default SvgFillRegisterQuick;